<template>
  <v-container class="container">
    <div>
      <h3>
        <v-icon class="mt-n1 mr-1" style="font-size: 35px">
          mdi-file-excel
        </v-icon>
        Carga excel Multas
      </h3>
      <h6 class="mt-n2 ml-10">Carga masiva de multas a través de excel</h6>
    </div>

    <v-card class="mt-10">
      <v-card-text>
        <!-- Descarga plantilla -->
        <v-row>
          <p class="ml-8 subtitle">
            Descargar plantilla de Carga
            <a href="/files/FormularioMultas.xlsx" download>Pinchando Aqui</a>
          </p>
        </v-row>

        <!-- Carga archivo -->
        <v-row>
          <v-file-input
            v-model="file"
            label="Seleccionar archivo"
            outlined
            :rules="fileRules"
            accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
            dense
            @change="onChange"
          ></v-file-input>
        </v-row>

                <!-- Barra de progreso -->
        <v-row v-if="isUploading || processedCount > 0" class="mt-4">
          <v-col cols="12">
            <div class="mb-1">
              Procesando {{ processedCount }} / {{ totalMultas }} multas
              ({{ uploadProgress }}%)
            </div>
            <v-progress-linear
              :value="uploadProgress"
              height="16"
              striped
            ></v-progress-linear>
            <div class="mt-1 caption">
              Correctas: {{ successCount }} |
              Con error: {{ errorCount }} |
              En curso (máx 10 concurrentes): {{ runningRequests }}
            </div>
          </v-col>
        </v-row>

        <!-- Tabla con estados por fila -->
        <v-row>
          <v-col>
            <v-data-table
              :headers="headers"
              :items="multas"
              class="elevation-1 mt-5"
              disable-pagination
              hide-default-footer
              :item-class="getRowClass"
            >
              <template v-slot:[`item.id_tipoeleccion`]="{ item }">
                {{ tipoEleccion[item.id_tipoeleccion] && tipoEleccion[item.id_tipoeleccion].value }}
              </template>

              <template v-slot:[`item.id_tipoevento`]="{ item }">
                {{ tipoEvento[item.id_tipoevento] && tipoEvento[item.id_tipoevento].value }}
              </template>

              <template v-slot:[`item.status`]="{ item }">
                <span v-if="item.status === 'success'">OK</span>
                <span v-else-if="item.status === 'error'">Error</span>
                <span v-else-if="item.status === 'sending'">Enviando...</span>
                <span v-else>-</span>
              </template>

              <template v-slot:[`item.error`]="{ item }">
                <span v-if="item.status === 'error'">
                  {{ item.error }}
                </span>
              </template>
            </v-data-table>
          </v-col>
        </v-row>



        <!-- Botones -->
        <v-row class="mt-4">
          <v-col class="d-flex justify-end" cols="12">
            <v-btn
              color="primary"
              @click="sendExcel"
              :disabled="!canSend"
            >
              Enviar Multas
            </v-btn>

            <v-btn
              class="ml-2"
              color="secondary"
              outlined
              @click="downloadResultados"
              :disabled="!canDownloadResultados"
            >
              Descargar resultados
            </v-btn>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import * as XLSX from "xlsx";
import { MultasService } from "../../util/Api/Multas/calls";
import { mapGetters } from "vuex";
import { Loading } from "element-ui";
import Swal from "sweetalert2";

export default {
  name: "IngresoMultaComponents",
  data() {
    return {
      file: null,
      jsonData: null,
      multas: [],
      loadingInstance: null,

      fileRules: [
        v => !!v || "Debe seleccionar un archivo",
        v =>
          !v ||
          v.size <= 5 * 1024 * 1024 ||
          "El archivo no debe superar los 5MB",
        v =>
          !v ||
          v.type.includes("spreadsheetml") ||
          v.type.includes("ms-excel") ||
          "El archivo debe ser un .xlsx"
      ],

      headers: [
        { text: "nombres", value: "nombres" },
        { text: "paterno", value: "paterno" },
        { text: "materno", value: "materno" },
        { text: "rut", value: "rut" },
        { text: "dv", value: "dv" },
        { text: "motivo", value: "motivo" },
        { text: "montomulta", value: "montomulta" },
        { text: "moneda", value: "moneda" },
        { text: "id_tipoeleccion", value: "id_tipoeleccion" },
        { text: "id_tipoevento", value: "id_tipoevento" },
        { text: "email", value: "email" },
        { text: "vencimiento", value: "vencimiento" },
        { text: "fechaevento", value: "fechaevento" },
        { text: "fechaemision", value: "fechaemision" },
        { text: "comuna", value: "comuna" },
        { text: "calle", value: "calle" },
        { text: "telefono", value: "telefono" },
        { text: "oficina", value: "oficina" },
        { text: "block", value: "block" },
        { text: "villa", value: "villa" },
        { text: "Estado", value: "status" },
        { text: "Detalle error", value: "error" }
      ],

      tipoEleccion: [
        { id: 0, value: "SIN ELECCIÓN" },
        { id: 1, value: "Presidente" },
        { id: 2, value: "Senadores" },
        { id: 3, value: "Diputados" },
        { id: 4, value: "Alcaldes" },
        { id: 5, value: "Concejales" },
        { id: 6, value: "Consejeros" },
        { id: 7, value: "Plebiscito" },
        { id: 8, value: "Gore" },
        { id: 9, value: "Consejero Constitucional" }
      ],

      tipoEvento: [
        {},
        { id: 1, value: "Precandidatura" },
        { id: 2, value: "Primaria" },
        { id: 3, value: "Definitiva" },
        { id: 4, value: "Segunda Votacion" }
      ],

      // estado envío
      isUploading: false,
      uploadProgress: 0,
      totalMultas: 0,
      processedCount: 0,
      successCount: 0,
      errorCount: 0,
      runningRequests: 0,
      nextIndex: 0
    };
  },
  computed: {
    ...mapGetters(["getPerfil"]),
    isFileValid() {
      if (!this.file) return false;
      return this.fileRules.every(rule => rule(this.file) === true);
    },
    canSend() {
      return (
        !this.isUploading &&
        this.isFileValid &&
        Array.isArray(this.multas) &&
        this.multas.length > 0
      );
    },
    canDownloadResultados() {
      return (
        !this.isUploading &&
        Array.isArray(this.multas) &&
        this.multas.length > 0 &&
        (this.successCount > 0 || this.errorCount > 0)
      );
    }
  },
  methods: {
    onChange() {
      this.jsonData = null;
      this.multas = [];
      this.resetState();
      this.readExcel();
    },

    resetState() {
      this.isUploading = false;
      this.uploadProgress = 0;
      this.totalMultas = 0;
      this.processedCount = 0;
      this.successCount = 0;
      this.errorCount = 0;
      this.runningRequests = 0;
      this.nextIndex = 0;
    },

    readExcel() {
      this.resetState();

      this.loadingInstance = Loading.service({
        fullscreen: true,
        text: "Cargando...",
        background: "rgba(0, 0, 0, 0.8)"
      });

      try {
        if (!this.file) {
          this.loadingInstance.close();
          return;
        }

        const reader = new FileReader();

        reader.onload = e => {
          try {
            const data = e.target.result;
            const workbook = XLSX.read(data, {
              type: "binary",
              cellDates: true,
              dateNF: "yyyy-mm-dd",
              cellNF: false,
              cellText: false
            });

            const firstSheetName = workbook.SheetNames[0];
            const worksheet = workbook.Sheets[firstSheetName];

            // Read rows; keep cell values but skip rows that are completely empty (only table borders, etc.)
            this.jsonData = XLSX.utils.sheet_to_json(worksheet, {
              defval: null
            }).filter(row =>
              Object.values(row || {}).some(
                value =>
                  value !== null &&
                  value !== undefined &&
                  String(value).trim() !== ""
              )
            );

            const requiredFields = [
              "id_tipoeleccion",
              "id_tipoevento",
              "rut",
              "fechaemision",
              "dv",
              "moneda",
              "montomulta",
              "vencimiento",
              "motivo",
              "paterno"
            ];

            const normalizeDate = value => {
              if (!value) return null;
              if (value instanceof Date) {
                const y = value.getFullYear();
                const m = String(value.getMonth() + 1).padStart(2, "0");
                const d = String(value.getDate()).padStart(2, "0");
                return `${y}-${m}-${d}`;
              }
              return String(value);
            };

            this.multas = this.jsonData.map((obj, index) => {
              requiredFields.forEach(field => {
                if (!Object.prototype.hasOwnProperty.call(obj, field)) {
                  throw `La multa en la fila ${
                    index + 2
                  } no contiene el campo obligatorio: ${field}`;
                }
              });

              return {
                ...obj,
                vencimiento: normalizeDate(obj.vencimiento),
                fechaevento: normalizeDate(obj.fechaevento),
                fechaemision: normalizeDate(obj.fechaemision),
                id_tipoeleccion: Number(obj.id_tipoeleccion),
                id_tipoevento: Number(obj.id_tipoevento),
                rut: Number(obj.rut),
                dv: String(obj.dv),
                moneda: String(obj.moneda),
                montomulta: parseFloat(
                  String(obj.montomulta).replace(",", ".")
                ).toFixed(4),
                motivo: Number(obj.motivo),
                paterno: String(obj.paterno),
                materno: obj.materno ? String(obj.materno) : null,
                nombres: obj.nombres ? String(obj.nombres) : null,
                calle: obj.calle ? String(obj.calle) : null,
                comuna: obj.comuna ? String(obj.comuna) : null,
                telefono: obj.telefono ? String(obj.telefono) : null,
                oficina: obj.oficina ? String(obj.oficina) : null,
                block: obj.block ? String(obj.block) : null,
                villa: obj.villa ? String(obj.villa) : null,
                email: obj.email ? String(obj.email) : null,
                status: null,
                error: null
              };
            });

            this.loadingInstance.close();
          } catch (error) {
            console.log("error", error);
            this.loadingInstance.close();
            Swal.fire({
              type: "error",
              html: `Ocurrió un problema al cargar los datos.<br/>Error: ${error}`
            });
          }
        };

        reader.readAsBinaryString(this.file);
      } catch (error) {
        console.log("error", error);
        if (this.loadingInstance) this.loadingInstance.close();
        Swal.fire({
          type: "error",
          html: `Ocurrió un problema al leer el archivo, contacte a Desarrollo antes de continuar.<br/>Error: ${error}`
        });
      }
    },

    getRowClass(item) {
      if (item.status === "success") return "row-success";
      if (item.status === "error") return "row-error";
      if (item.status === "sending") return "row-sending";
      return "";
    },

    async sendExcel() {
      if (!this.canSend) {
        Swal.fire({
          type: "warning",
          html: "Debe cargar un archivo válido con multas antes de enviar."
        });
        return;
      }

      this.resetState();
      this.isUploading = true;
      this.totalMultas = this.multas.length;

      // limpiar estados (por si reintentas)
      this.multas.forEach(m => {
        m.status = null;
        m.error = null;
      });

      const concurrency = 10;
      const total = this.totalMultas;
      this.nextIndex = 0;

      // Loading overlay durante el envío
      this.loadingInstance = Loading.service({
        fullscreen: true,
        text: `Enviando multas... 0%`,
        background: "rgba(0, 0, 0, 0.8)"
      });

      const sendOne = async rowIndex => {
        const multa = this.multas[rowIndex];

        this.$set(this.multas[rowIndex], "status", "sending");
        this.$set(this.multas[rowIndex], "error", null);

        this.runningRequests++;

        try {
          const body = {
            idusuario: this.getPerfil.id,
            idsubdireccion: this.getPerfil.subdireccion_id,
            // Si tu backend acepta solo array, dejamos [multa]
            data: [multa]
          };

          const resp = await MultasService.send(body);

          if (resp && (resp.statusCode === 200 || resp.statusCode === 201)) {
            this.$set(this.multas[rowIndex], "status", "success");
            this.successCount++;
          } else {
            this.$set(this.multas[rowIndex], "status", "error");
            this.$set(
              this.multas[rowIndex],
              "error",
              (resp && (resp.msg || resp.message)) ||
                "Error desconocido en la respuesta."
            );
            this.errorCount++;
          }
        } catch (error) {
          this.$set(this.multas[rowIndex], "status", "error");
          this.$set(
            this.multas[rowIndex],
            "error",
            (error && error.message) ||
              JSON.stringify(error) ||
              "Error al intentar enviar la multa."
          );
          this.errorCount++;
        } finally {
          this.runningRequests--;
          this.processedCount++;
          this.uploadProgress = Math.round(
            (this.processedCount / total) * 100
          );

          // Actualizar texto del overlay para que se vea el avance
          if (this.loadingInstance) {
            this.loadingInstance.text = `Enviando multas... ${this.uploadProgress}% (${this.processedCount}/${this.totalMultas})`;
          }
        }
      };

      const worker = async () => {
        while (true) {
          const current = this.nextIndex++;
          if (current >= total) break;
          await sendOne(current);
        }
      };

      const workers = [];
      const workerCount = Math.min(concurrency, total);
      for (let i = 0; i < workerCount; i++) {
        workers.push(worker());
      }

      await Promise.all(workers);

      this.isUploading = false;

      if (this.loadingInstance) {
        this.loadingInstance.close();
      }

      if (this.errorCount === 0) {
        Swal.fire({
          type: "success",
          html: `Todas las multas fueron enviadas correctamente (${this.successCount}/${this.totalMultas}).`
        });
      } else if (this.successCount === 0) {
        Swal.fire({
          type: "error",
          html: `Todas las multas fallaron (${this.errorCount}/${this.totalMultas}). Revise la tabla para más detalles.`
        });
      } else {
        Swal.fire({
          type: "warning",
          html: `
            Proceso finalizado con errores parciales.<br/>
            Correctas: ${this.successCount}<br/>
            Con error: ${this.errorCount}<br/>
            Puede descargar el detalle con el botón "Descargar resultados".
          `
        });
      }
    },

    downloadResultados() {
      if (!this.canDownloadResultados) {
        Swal.fire({
          type: "warning",
          html: "No hay resultados para descargar."
        });
        return;
      }

      // construimos json para exportar
      const data = this.multas.map(m => {
        const resultado =
          m.status === "success"
            ? "CREADO"
            : m.status === "error"
            ? "ERROR"
            : "";

        return {
          nombres: m.nombres || "",
          paterno: m.paterno || "",
          materno: m.materno || "",
          rut: m.rut || "",
          dv: m.dv || "",
          motivo: m.motivo || "",
          montomulta: m.montomulta || "",
          moneda: m.moneda || "",
          id_tipoeleccion: m.id_tipoeleccion || "",
          id_tipoevento: m.id_tipoevento || "",
          email: m.email || "",
          vencimiento: m.vencimiento || "",
          fechaevento: m.fechaevento || "",
          fechaemision: m.fechaemision || "",
          comuna: m.comuna || "",
          calle: m.calle || "",
          telefono: m.telefono || "",
          oficina: m.oficina || "",
          block: m.block || "",
          villa: m.villa || "",
          resultado,
          detalle_error: m.status === "error" ? m.error || "" : ""
        };
      });

      const ws = XLSX.utils.json_to_sheet(data);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "Resultados");

      const wbout = XLSX.write(wb, { bookType: "xlsx", type: "array" });
      const blob = new Blob([wbout], {
        type:
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
      });

      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = `resultado_multas_${new Date()
        .toISOString()
        .slice(0, 10)}.xlsx`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      window.URL.revokeObjectURL(url);
    }
  }
};
</script>

<style scoped>
.container {
  text-align: start !important;
}

.row-success {
  background-color: rgba(76, 175, 80, 0.14) !important; /* verde suave */
}

.row-error {
  background-color: rgba(244, 67, 54, 0.14) !important; /* rojo suave */
}

.row-sending {
  background-color: rgba(255, 235, 59, 0.16) !important; /* amarillo suave */
}
</style>
